import React, { Component } from 'react';
import {
    Alert,
    Badge,
    Card,
    CardBody,
    CardHeader,
    Col,
    Collapse,
    Container,
    Row,
    Table
} from 'reactstrap';
import { withRouter, Link } from 'react-router-dom';

import BreadCrumb from '../../Components/Common/BreadCrumb';
import { ClassRoomAPI } from "api";
import { Loading, Utils } from "custom";


class PendingPaymentsList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: false,
            list: [],
            expanded: {}
        };
        document.title = "Pagamenti in attesa | CLTV Cloud";
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        this.setState({ loading: true, error: false });

        ClassRoomAPI.pendingPayments().then((list) => {

            let isAdmin = (Utils.getUserData().role === "ADMIN");
            let expanded = {};

            // Per il consulente espandiamo di default; per l'admin tutto chiuso
            if (!isAdmin) {
                for (let i = 0; i < list.length; i++) {
                    let key = (list[i].consulent !== null) ? list[i].consulent.id : "null";
                    expanded[key] = true;
                }
            }

            this.setState({ list: list, expanded: expanded, loading: false });
        }).catch((e) => {
            console.error(e);
            this.setState({ loading: false, error: true });
        });
    };

    toggle = (key) => {
        this.setState((s) => ({
            expanded: { ...s.expanded, [key]: !s.expanded[key] }
        }));
    };

    classroomLink = (classroomId) => {
        let isAdmin = (Utils.getUserData().role === "ADMIN");
        return (isAdmin) ? "/classroom/" + classroomId : "/classroom/inside/" + classroomId;
    };

    renderStatusBadge = (status) => {
        if (status === "DEPOSIT")
            return <Badge color="info" style={{ fontSize: "12px" }}>Acconto</Badge>;
        if (status === "NOT_PAYED")
            return <Badge color="danger" style={{ fontSize: "12px" }}>Non pagato</Badge>;
        if (status === "LEAD")
            return <Badge color="warning" style={{ fontSize: "12px" }}>Lead</Badge>;
        return null;
    };

    renderImporto = (item) => {
        if (item.type === "LEAD")
            return <span className="text-muted">-</span>;

        if (item.status === "NOT_PAYED")
            return <span>€ 0 / € {item.total.toFixed(2)}</span>;

        return <span>€ {item.payed.toFixed(2)} / € {item.total.toFixed(2)} <span className="text-danger">(mancano € {item.remaining.toFixed(2)})</span></span>;
    };

    renderConsulentBlock = (entry, isAdmin) => {
        let key = (entry.consulent !== null) ? entry.consulent.id : "null";
        let isOpen = !!this.state.expanded[key];

        let header = (entry.consulent !== null) ? <span><b>{entry.consulent.firstname} {entry.consulent.lastname}</b></span> : <span className="text-muted"><i>Senza consulente</i></span>;

        return (
            <Card key={key} className="mb-2">
                {(isAdmin) ? <CardHeader
                    className="cursor-pointer d-flex justify-content-between align-items-center"
                    onClick={() => this.toggle(key)}
                >
                    <div>
                        <i className={"mdi me-2 " + (isOpen ? "mdi-chevron-down" : "mdi-chevron-right")}></i>
                        {header}
                        <span className="text-muted ms-2">· {entry.totals.all} in attesa</span>
                    </div>
                    <div>
                        {(entry.totals.notPayed > 0) ? <Badge color="danger" className="me-1">Non pagato: {entry.totals.notPayed}</Badge> : null}
                        {(entry.totals.deposit > 0) ? <Badge color="info" className="me-1">Acconto: {entry.totals.deposit}</Badge> : null}
                        {(entry.totals.lead > 0) ? <Badge color="warning" className="me-1">Lead: {entry.totals.lead}</Badge> : null}
                    </div>
                </CardHeader> : null}

                <Collapse isOpen={isOpen}>
                    <CardBody>
                        {(entry.items.length === 0) ? <Alert color="light" className="mb-0">Nessun pagamento in attesa.</Alert> : <div className="table-responsive">
                            <Table hover className="align-middle mb-0">
                                <thead>
                                    <tr>
                                        <th>Cliente</th>
                                        <th>Classe</th>
                                        <th>Stato</th>
                                        <th>Importo</th>
                                        <th className="text-end">Azione</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {entry.items.map((item, idx) => {
                                        return <tr key={idx}>
                                            <td>
                                                {(item.type === "SELL" && item.client && item.client.id) ? <Link to={"/client/" + item.client.id} className="text-primary">
                                                    {item.client.firstname} {item.client.lastname}
                                                </Link> : <span>{item.client?.name || item.client?.firstname + " " + item.client?.lastname}</span>}
                                            </td>
                                            <td>
                                                <Link to={this.classroomLink(item.classroom.id)} className="text-primary">
                                                    {item.classroom.name}
                                                </Link>
                                            </td>
                                            <td>{this.renderStatusBadge(item.status)}</td>
                                            <td>{this.renderImporto(item)}</td>
                                            <td className="text-end">
                                                {(item.type === "SELL") ? <Link to={"/sell/" + item.sell_id}>
                                                    <button className="btn btn-sm btn-light"><i className="ri-eye-line"></i> Vendita</button>
                                                </Link> : <span className="text-muted small">-</span>}
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </Table>
                        </div>}
                    </CardBody>
                </Collapse>
            </Card>
        );
    };

    render() {
        let isAdmin = (Utils.getUserData().role === "ADMIN");

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <BreadCrumb title="Pagamenti in attesa" pageTitle="Classi" />

                        <Row>
                            <Col lg={12}>
                                {(this.state.loading) ? <Loading /> :
                                    (this.state.error) ? <Alert color="danger">Errore nel caricamento dei pagamenti in attesa.</Alert> :
                                    (this.state.list.length === 0) ? <Alert color="success" className="mb-0"><i className="ri-checkbox-circle-line align-bottom me-1"></i> Nessun pagamento in attesa.</Alert> :
                                    this.state.list.map((entry) => this.renderConsulentBlock(entry, isAdmin))
                                }
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(PendingPaymentsList);
